/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import styled, { css } from "styled-components";
import { theme } from "@nordcloud/gnui";

type TextButtonProps = {
  underline?: boolean;
};

export const TextButton = styled.button<TextButtonProps>`
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  color: ${theme.color.text.text01};
  cursor: pointer;
  text-decoration: none;

  ${(props) =>
    props.underline &&
    css`
      text-decoration: underline;
      text-underline-offset: ${theme.spacing.spacing01};
    `}

  &:hover {
    color: ${theme.color.text.text02};
  }
`;
